/**
 * Global constants for Anoki Labs
 */

/**
 * Contact email for demo requests and general inquiries
 */
export const CONTACT_EMAIL = 'labs@anoki.ai'

/**
 * Navigation height in pixels (should match --nav-height CSS variable)
 */
export const NAV_HEIGHT = 80
